import React from "react";
import { InteractionType } from "../../../models/interactions/Interaction";
import { AllInteractions } from "../../interaction_picker/InteractionDefinitions";
import { useInteractionPickerIcons } from "../../interaction_picker/InteractionPickerIconHooks";

/**
 * Header bar for interaction popups (Design Studio `screens/popup-headers/a-header-bar.html`):
 * the type's icon in a small tile and the title, with a hairline under the bar.
 * Pass it to PiPopupWindowPreview's `header` prop. `trailing` is for a short summary on
 * the right (e.g. a conversation's cast); leave it out when the body already says it.
 */
export default function PiPopupHeaderBar(props: {
  interactionType: InteractionType;
  title: string;
  trailing?: React.ReactNode;
}) {
  const [getIcon] = useInteractionPickerIcons();
  const definition = AllInteractions.find((d) => d.type === props.interactionType);

  return (
    <div
      className="flex flex-none items-center gap-3 h-[64px] px-6 box-border border-b border-solid border-x-0 border-t-0 border-interaction-primary-washed"
      data-testid="popup-header-bar"
    >
      {definition && (
        <span
          className="flex flex-none items-center justify-center w-[32px] h-[32px] rounded-lg bg-interaction-primary-washed text-interaction-primary text-[18px]"
          aria-hidden="true"
        >
          {getIcon(definition)}
        </span>
      )}
      <h2 className="m-0 min-w-0 truncate text-[18px] font-semibold text-interaction-primary">
        {props.title}
      </h2>
      {props.trailing && <div className="flex flex-none items-center ml-auto">{props.trailing}</div>}
    </div>
  );
}
